
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M19.2381 5.68421C19.2381 7.71894 15.8269 9.36842 11.619 9.36842C7.41116 9.36842 4 7.71894 4 5.68421M19.2381 5.68421C19.2381 3.64948 15.8269 2 11.619 2C7.41116 2 4 3.64948 4 5.68421M19.2381 5.68421V9.89474C19.2381 9.89474 19.2381 11.035 19.2381 12.5263M4 5.68421V12.5263M4 12.5263C4 14.3525 4 16.9024 4 18.2408C4 18.8358 4.13098 19.4319 4.55243 19.8519C5.40151 20.6981 7.39436 22 11.619 22C15.8437 22 17.8366 20.6981 18.6857 19.8519C19.1071 19.4319 19.2381 18.8358 19.2381 18.2408C19.2381 16.9125 19.2381 14.3869 19.2381 12.5263M4 12.5263C4 12.5263 6.82993 15.3333 11.619 15.3333C16.4082 15.3333 19.2381 12.5263 19.2381 12.5263"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiPagedata",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
